const BLACKLISTED_COUNTRIES = [
  'IR', // Iran
  'SY', // Syria
  'KP', // North Korea
  'LB', // Lebanon
  'PK', // Pakistan
  'YE', // Yemen
  'SD', // Sudan
  'AF', // Afghanistan
  'PS', // Gaza Strip/Palestinian Territories
  'IQ', // Iraq
  'SS', // South Sudan
  'RU', // Russia
  'QA', // Qatar
  'KW', // Kuwait
]

export async function checkCountryRestrictions() {
  try {
    const response = await fetch('https://ipapi.co/json/')
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()

    if (BLACKLISTED_COUNTRIES.includes(data.country)) {
      console.log(
        `Blocked checkout from ${data.country_name} (${data.country})`
      )
      return { isBlocked: true, countryData: data }
    }

    return { isBlocked: false, countryData: data }
  } catch (error) {
    console.error('Country check failed:', error)
    // In case of error, don't block the checkout process
    return { isBlocked: false, countryData: null }
  }
}

export { BLACKLISTED_COUNTRIES }
